import allFrequentlyAskedQuestions from "./frequentlyAskedQuestions/data/all.json";

export default allFrequentlyAskedQuestions;
